var navigation = responsiveNav(".nav-main", {
	animate: true,                    // Boolean: Use CSS3 transitions, true or false
	transition: 284,                  // Integer: Speed of the transition, in milliseconds
	label: "",                        // String: Label for the navigation toggle
	insert: "before",                 // String: Insert the toggle before or after the navigation
	customToggle: "#nav-toggle",      // Selector: Specify the ID of a custom toggle
	closeOnNavClick: true,            // Boolean: Close the navigation when one of the links are clicked
	openPos: "relative",              // String: Position of the opened nav, relative or static
	navClass: "nav-main",             // String: Default CSS class. If changed, you need to edit the CSS too!
	navActiveClass: "js-nav-active",  // String: Class that is added to <html> element when nav is active
	jsClass: "js",                    // String: 'JS enabled' class which is added to <html> element
});

/* GOOGLE MAP */
var cmsLat = jQuery('.map-container').attr('data-lat');
var cmsLng = jQuery('.map-container').attr('data-lng');
var autocompleteMap;
var autocompleteMarker = null;
var autocompleteField = null;
var defaultZoom = 15;

var GoogleMap = function () {

	var image = new google.maps.MarkerImage('/wp-content/themes/essentiel/img/pointer.png', null, null, null, new google.maps.Size(47, 55));

	simpleMap = new GMaps({
		div: '#map-container',
		lat: cmsLat,
		lng: cmsLng,
		zoom: defaultZoom,
		scrollwheel: false,
		disableDefaultUI: false,
		options: {
			'mapTypeId': google.maps.MapTypeId.ROADMAP
		}
	});

	simpleMap.addMarker({
		lat: cmsLat,
		lng: cmsLng,
		icon: image
	});


};


// jQuery stuff
jQuery(document).ready(function ($) {
	FastClick.attach(document.body);

	/* Google Map */
	if ($("#map-container").length) GoogleMap();

	/* Select 2 */
	$('.wpas-select').select2({
		allowClear: true,
		minimumResultsForSearch: 12,
	});


	$('.last-product__col').matchHeight();
	$('.cartouche__col-inner').matchHeight();

	/* Charte qualité */

	// $('.policy-list__title').click(function() {
	// 	$(this).next('.policy-list__content').slideToggle();
	// });

	$('.toggle').click(function (e) {
		e.preventDefault();
		$('.toggle-content').slideToggle();
	});

	$('.inline-form__btn').click(function (e) {
		e.preventDefault();
		$(this).next('.inline-form__form').toggleClass('show');
	});

	$('.search-toggle').click(function (e) {
		e.preventDefault();
		$('.search-zone__form').slideToggle();
	});

	$('.popup-dossier').magnificPopup({
		type: 'inline'
	});

	if ($('#popup__specialoffer').length && ($.cookie('popup') != "shown")) {
		$.magnificPopup.open({
			items: {src: '#popup__specialoffer'},
			type: 'inline'
		}, 0);

		// On met en place un cookie qui expire au bout de 7 jours pour tester 
		// l'affichage du popup lors des prochianes visites
		$.cookie('popup', 'shown', {
			expires: 7, path: '/'
		});
	}

	var autocompleteId = document.getElementById("mapAddressAutocomplete");

	if (autocompleteId) {

		var defaultBounds = new google.maps.LatLngBounds(
			new google.maps.LatLng(41, -5),
			new google.maps.LatLng(51.589626, 8.835930));

		var input = document.getElementById('adresseBien');

		autocompleteField = new google.maps.places.Autocomplete(input, {
			bounds: defaultBounds,
			componentRestrictions: {country: 'fr'},
		});
		autocompleteField.addListener("place_changed", onPlaceChanged);

		autocompleteMap = new google.maps.Map(autocompleteId, {
			zoom: 5,
			center: {lat: 46.2, lng: 2.2},
			mapTypeControl: false,
			panControl: false,
			zoomControl: false,
			fullscreenControl: false,
			gestureHandling: "none",
			streetViewControl: false
		});
	}
});

function onPlaceChanged() {
	var place = autocompleteField.getPlace();

	if (autocompleteMarker) {
		autocompleteMarker.setMap(null);
	}
	if (place.geometry) {
		autocompleteMap.panTo(place.geometry.location);
		autocompleteMap.setZoom(15);
		autocompleteMarker = new google.maps.Marker({
			position: place.geometry.location,
			animation: google.maps.Animation.DROP
		});
		autocompleteMarker.setMap(autocompleteMap);
	} else {
		input.placeholder = "Indiquez une adresse";
	}
}
